const groupCaseStudies = [
  {
    id: 'universities',
    text: 'UNSW Sydney connects thousands of graduates around the globe using Kintell.',
    imgId: 'unsw',
    link: 'for-universities',
  },
  {
    id: 'schools',
    text: 'The University of Sydney Business School is powered by Kintell to connect MBA students with facilitators.',
    imgId: 'usyd',
    link: 'for-educators',
  },
  {
    id: 'ukraine',
    text: 'Thousands of Ukrainian are connected with foreign language tutors using Kintell.',
    imgId: 'lcu',
    link: 'for-ukraine',
  },
]

export default {
  profileShare: {
    title: 'Share your Kintell profile',
    body: ' If you’d like to share your Kintell profile page with a friend or colleague, simply copy the URL below.',
    copy: 'Copy',
    share: 'Share',
    preview: 'preview'
  },
  welcome: {
    learner: {
      title: 'Welcome to the Kintell community!',
      body: 'Hi {name}, you’re now signed up to Kintell! Woop! You can now either browse our Advisors or become an Advisor yourself by creating a Kintell Card.',
    },
  },
  whatIsKintell: {
    title: 'What is Kintell?',
    body: 'Kintell is the global knowledge network - a new way of getting and giving independent advice.'
  },
  caseStudies: {
    group: [ ...groupCaseStudies ],
    individual: [
      {
        id: 'consultants',
        text: 'Gretchen Dobson is a global engagement consultant who connects with her clients around the world using Kintell.',
        imgId: 'gretchen',
        link: 'for-consultants',
      },
      {
        id: 'educators',
        text: 'Find out how Kintell helps Prof. Patrick Medley organise and conduct 1-to-1 and group tutorials with his MBA students.',
        imgId: 'patrick',
        link: 'for-educators',
      },
      {
        id: 'coaches',
        text: 'Discover how Danielle Neale uses Kintell to add flexibility and visibility to her startup coaching practice.',
        imgId: 'danielle',
        link: 'for-coaches',
      },
      ...groupCaseStudies
    ],
  }
}
